import { i18n } from 'i18n';

// import { TRANSFORM_LOCALE } from './transformLocale';

export const formatDate = (
	date: Date | null,
	format: 'short' | 'medium' | 'long' | 'json' | 'shortNumeric' | 'longNumeric' = 'short',
	filter: 'from' | 'to' = 'from',
) => {
	if (!date) {
		return null;
	}
	// const locale = TRANSFORM_LOCALE[i18n.language];
	const locale = i18n.language;
	switch (format) {
		case 'shortNumeric':
			return date.toLocaleString(locale, {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
			});

		case 'longNumeric':
			return date.toLocaleString(locale, {
				month: 'long',
				day: 'numeric',
				year: 'numeric',
			});

		case 'short':
			return date.toLocaleString(locale, {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
			});

		case 'medium':
			return date.toLocaleString(locale, {
				month: '2-digit',
				day: '2-digit',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

		case 'long':
			return date.toLocaleString(locale, {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: '2-digit',
				minute: '2-digit',
			});

		case 'json':
			if (filter === 'to') {
				date.setDate(date.getDate() + 1);
				date.setMilliseconds(date.getMilliseconds() - 1);
			}

			return date.toJSON();

		default:
			return null;
	}
};
